import { Checkbox } from '@timelyapp/react';
import classNames from 'classnames';
import DiagnosticResourceId from 'components/dev-tools/DiagnosticResourceId';
import styles from 'components/dropdowns/FilterDropdownItem.module.scss';
import Label from 'components/Label';
import React from 'react';

interface BaseProps {
  checked: boolean;
  disabled?: boolean;
  partiallyChecked?: boolean;
  indent?: boolean;
  hasCheckbox?: boolean;
  resource?: string;
  selectedCount?: number;
  totalCount?: number;
  countNotFullyLoaded?: boolean;
  variant?: 'secondary';
  nonSelectable?: boolean;
}

interface BaseItem {
  name?: string;
  label: string;
  value: string | number;
  image?: string;
  active?: boolean;
  resource?: string;
  currencySymbol?: string;
}

interface Props<T> extends BaseProps {
  item: T;
}

const FilterDropDownItem = <T extends BaseItem>(props: Props<T>) => {
  const {
    item,
    checked,
    partiallyChecked,
    disabled,
    indent,
    hasCheckbox = true,
    resource,
    nonSelectable,
  } = props;
  return (
    <div
      className={classNames('fs-mask', styles.item, styles[`variant-${props.variant}`], {
        [styles.indentedChild]: indent,
        [styles.nonSelectable]: nonSelectable,
      })}
    >
      {hasCheckbox && (
        <>
          <Checkbox
            readOnly
            checked={checked && !partiallyChecked}
            indeterminate={partiallyChecked}
            className={styles.checkbox}
            disabled={disabled}
          />
        </>
      )}
      {item.image && (
        <img
          style={{ width: 14, margin: '0 5px' }}
          className="fs-exclude"
          src={item.image}
          alt={item.name}
          title={item.name}
        />
      )}
      {resource != null && <DiagnosticResourceId resource={resource} id={item.value} />}
      <div className={styles.label} title={item.label}>
        {item.label}
      </div>
      {item.active === false ? (
        <Label size="small" variant="muted-danger" className={styles.archivedLabel}>
          Archived
        </Label>
      ) : item.currencySymbol ? (
        <span className={styles.currencySymbol}>{item.currencySymbol}</span>
      ) : null}
      {props.selectedCount != null && props.totalCount != null && (
        <div className={styles.counts}>
          {props.selectedCount}
          {props.countNotFullyLoaded ? '+' : ''}/{props.totalCount}
        </div>
      )}
    </div>
  );
};

export default FilterDropDownItem;
